import React from 'react';
import { Target, Users, Brain, Award } from 'lucide-react';
import { personalInfo } from '../data/mock';

const About = () => {
  const highlights = [
    {
      icon: Target,
      title: "C-Level Placement Expert",
      description: "Successfully completed 50+ executive search mandates for CEO, CFO, and C-suite positions across Fortune 500 and high-growth companies."
    },
    {
      icon: Users,
      title: "Deep Industry Network",
      description: "Cultivated an extensive network of 5,000+ senior executives across Technology, FMCG, Industrial, and Financial Services sectors."
    },
    {
      icon: Brain,
      title: "Strategic Talent Advisory",
      description: "Providing clients with market intelligence, competitor mapping, and compensation benchmarking to inform critical hiring decisions."
    },
    {
      icon: Award,
      title: "Trusted Partner",
      description: "Recognized for discretion, integrity, and consistently delivering qualified shortlists within demanding timelines."
    }
  ];

  return (
    <section id="about" className="py-24 bg-gray-950 relative">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <span className="text-gray-500 text-sm font-mono tracking-wider uppercase">Executive Search Consultant</span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
              Your Strategic Talent Partner
            </h2>
            <div className="w-20 h-1 bg-white mx-auto"></div>
          </div>

          {/* Main content */}
          <div className="grid md:grid-cols-2 gap-12 mb-16">
            <div className="space-y-6">
              <p className="text-gray-400 text-lg leading-relaxed">
                As an <span className="text-white font-semibold">Executive Recruitment Associate</span> at <span className="text-white font-semibold">TRANSEARCH International</span> — one of the world's leading executive search firms — I specialize in identifying and securing <span className="text-white font-semibold">transformational leaders</span> for organizations navigating complex market dynamics.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed">
                My approach combines <span className="text-white font-semibold">rigorous research methodology</span> with deep market intelligence. I don't just find candidates — I uncover <span className="text-white font-semibold">hidden talent</span> that competitors overlook, providing clients with access to executives who can drive measurable business impact.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed">
                With expertise spanning <span className="text-white font-semibold">15+ industries</span> including Technology, Consumer Goods, Industrial Manufacturing, and Professional Services, I bring sector-specific insights that accelerate the search process and ensure cultural alignment.
              </p>
            </div>

            <div className="space-y-6">
              <p className="text-gray-400 text-lg leading-relaxed">
                What sets me apart is a <span className="text-white font-semibold">consultative partnership approach</span>. I work closely with C-suite stakeholders to understand not just the role requirements, but the strategic vision, organizational culture, and leadership competencies that will determine long-term success.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed">
                My background in <span className="text-white font-semibold">psychology and behavioral assessment</span> enables me to evaluate candidates beyond technical qualifications — assessing leadership style, cultural fit, and potential for executive growth.
              </p>
              <div className="pt-4">
                <div className="text-white font-semibold mb-3">Core Specializations:</div>
                <div className="flex flex-wrap gap-3">
                  <span className="px-4 py-2 bg-gray-900 border border-gray-800 rounded-lg text-gray-300 text-sm">C-Level Search</span>
                  <span className="px-4 py-2 bg-gray-900 border border-gray-800 rounded-lg text-gray-300 text-sm">Board Advisory</span>
                  <span className="px-4 py-2 bg-gray-900 border border-gray-800 rounded-lg text-gray-300 text-sm">Market Mapping</span>
                  <span className="px-4 py-2 bg-gray-900 border border-gray-800 rounded-lg text-gray-300 text-sm">Leadership Assessment</span>
                </div>
              </div>
              <div className="pt-2">
                <div className="flex gap-4">
                  <span className="px-4 py-2 bg-gray-900 border border-gray-800 rounded-lg text-gray-300">🇹🇷 Turkish (Native)</span>
                  <span className="px-4 py-2 bg-gray-900 border border-gray-800 rounded-lg text-gray-300">🇬🇧 English (Upper-Intermediate)</span>
                </div>
              </div>
            </div>
          </div>

          {/* Highlight cards */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {highlights.map((item, index) => (
              <div
                key={index}
                className="bg-gray-900 border border-gray-800 rounded-xl p-6 hover:border-gray-700 transition-all duration-300 hover:transform hover:-translate-y-1"
              >
                <div className="bg-gray-800 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                  <item.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-white font-semibold mb-2 text-lg">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

